import { reportRaptorMetrics } from '@/src/common/SLRaptor';
import { HOME_PAGE_ERROR_CODE } from '../../home_page_main/utils/constant';

// https://km.sankuai.com/collabpage/2458082968
export class PreheatMonitor {
  // 通参 code bundleName

  /**
     * 兜底组件渲染命中次数
     */
  reportRender = (code: HOME_PAGE_ERROR_CODE, tags = {}) => {
    reportRaptorMetrics({ PreheatRender: 1 }, { ...tags, bundleName: Mach.env?.bundleName, code: `${code}` });
  }

  /**
     * 兜底组件正常展示次数
     * @param value code类型
     */
  reportRenderSuccess = (code: HOME_PAGE_ERROR_CODE, tags = {}) => {
    reportRaptorMetrics({ PreheatRenderSuccess: 1 }, { ...tags, bundleName: Mach.env?.bundleName, code: `${code}` });
  }

  /**
     * 兜底组件异常展示次数
     * @param value code类型
     */
  reportRenderError = (code: HOME_PAGE_ERROR_CODE, tags = {}) => {
    reportRaptorMetrics({ PreheatRenderError: 1 }, { ...tags, bundleName: Mach.env?.bundleName, code: `${code}` });
  }

  /**
     * 去登录点击次数
     */
  reportClickLogin = (code: HOME_PAGE_ERROR_CODE, tags = {}) => {
    reportRaptorMetrics({ PreheatClickLogin: 1 }, { ...tags, bundleName: Mach.env?.bundleName, code: `${code}` });
  }

  /**
     * 去逛逛点击次数
     */
  reportClickExplore = (code: HOME_PAGE_ERROR_CODE, tags = {}) => {
    reportRaptorMetrics({ PreheatClickExplore: 1 }, { ...tags, bundleName: Mach.env?.bundleName, code: `${code}` });
  }

  /**
     * 预热倒计时-首页刷新事件打点
     */
  reportCountDownSecondsRefresh = (tags = {}) => {
    reportRaptorMetrics({ CountDownSecondsRefresh: 1 }, { ...tags, bundleName: Mach.env?.bundleName });
  }

  /**
     * 预热倒计时-预热倒计时开启状态
     * 1->开启倒计时
     * 0->不开启
     */
  reportCountDownSecondsStatus = (status: number, tags = {}) => {
    reportRaptorMetrics({ CountDownSecondsStatus: 1 }, { ...tags, bundleName: Mach.env?.bundleName, status: `${status}` });
  }

  /**
     * 核按钮状态变更
     * @param status 核按钮 1启动轮询，2自动退出
     * @param tags
     */
  reportNuclearPollingStatus = (status: number, tags = {}) => {
    reportRaptorMetrics({ NuclearPollingStatus: 1 }, { ...tags, bundleName: Mach.env?.bundleName, status: `${status}` });
  }
}
